RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, sprintf) {

    'use strict';

    widgets.MetricLegendView = RivalIQ.views.LayoutView.mixin({
        template: '#widgetMetricLegendTemplate',
        className: 'metric-summary',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            chartLegend: '.x-chart-legend-region'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        behaviors: function () {
            const me = this;

            const metric = me.dashboardModel.metric;
            const information = metric.getInformation();

            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: information
                }
            };
        },

        loadData: function () {
            const me = this;

            const metrics = [me.dashboardModel.metric];

            if (me.dashboardModel.submetric) {
                metrics.push(me.dashboardModel.submetric);
            }

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);
            return collection.fetch()
                .done(function (collection) {
                    me.model = collection.first();

                    if (_.size(metrics) > 1) {
                        me.submetric = collection.last();
                    }
                });
        },

        onRender: function () {
            const me = this;

            me.$('[data-toggle="popover"]').popover();
        },

        onBeforeRender: function () {
            const me = this;

            me.showLegend();
        },

        showLegend: function () {
            const me = this;

            const legend = new App.views.SummaryItems({
                disableColors: Boolean(me.dashboardModel.disableColors),
                itemColumnSize: me.dashboardModel.itemColumnSize,
                collection: me.model.get('submetrics')
            });

            me.chartLegend.show(legend);
        },

        serializeData: function () {
            const me = this;

            const data = {
                hideMetric: Boolean(me.dashboardModel.hideMetric),
                metric: {
                    name: me.dashboardModel.getTitle() || me.model.getName(),
                    value: me.model.getValue(),
                    unabbreviatedValue: me.model.getValue({
                        expand: true
                    })
                },
                submetric: null
            };

            if (me.submetric) {
                data.submetric = {
                    name: me.submetric.getTitle() || me.submetric.getName(),
                    value: me.submetric.getValue()
                };

                const displayString = me.submetric.get('displayString');
                if (displayString) {
                    data.submetric.displayString = sprintf(displayString, data.submetric.value);
                }
            }

            return data;
        }
    });

    const MetricLegendWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: widgets.MetricLegendView,
        processProps: function (props) {
            const me = this;

            props = widgets.Chart.buildMetrics(me, props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_LEGEND, MetricLegendWidget);

}, window.s, window.sprintf);
